module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "aboutDashboard.b76631f0.png";